(function() {
  function initMegaMenuFlyouts() {
    // Set background on all meganav columns
jQuery('.meganav__scroller--has-list.meganav__list--multiple-columns .grid__item').css('background-color', '#d0d2d4');
jQuery('.meganav__scroller--has-list.meganav__list--multiple-columns .meganav__nav').css('background-color', '#d0d2d4');
jQuery('.meganav__scroller--has-list.meganav__list--multiple-columns .meganav__nav.page-width').css('background-color', '#d0d2d4');
jQuery('.meganav__scroller--has-list.meganav__list--multiple-columns .site-nav__dropdown-container').css('background-color', '#d0d2d4');
    jQuery('.meganav__scroller--has-list.meganav__list--multiple-columns').closest('.meganav').css('background-color', '#d0d2d4');
    jQuery('.site-header .meganav').css('background-color', '#d0d2d4');


    jQuery('.meganav__link--has-list').each(function() {
      var $linkLi = jQuery(this);
      if ($linkLi.data('flyoutInit')) return;
      $linkLi.data('flyoutInit', true);

      var $flyout = $linkLi.next('.site-nav__dropdown--third-level');
      if (!$flyout.length) return;

      $linkLi.on('mouseenter', function() {
        $linkLi.closest('.grid__item.meganav__list')
          .find('.site-nav__dropdown--third-level')
          .css({ visibility: 'hidden', opacity: '0' });
        $linkLi.closest('.grid__item.meganav__list')
          .find('.meganav__nav, .meganav__nav.page-width, .site-nav__dropdown-container')
          .css('background-color', '#d0d2d4');

        $linkLi.closest('.grid__item.meganav__list')
          .find('.meganav__link--has-list')
          .removeClass('meganav__link--active');
        $flyout.css({ visibility: 'visible', opacity: '1' });
        $linkLi.addClass('meganav__link--active');
      });

      $linkLi.on('mouseleave', function(e) {
        if (!$flyout[0].contains(e.relatedTarget)) {
          $flyout.css({ visibility: 'hidden', opacity: '0' });
          $linkLi.removeClass('meganav__link--active');
        }
      });

      $flyout.on('mouseleave', function(e) {
        if (!$linkLi[0].contains(e.relatedTarget)) {
          $flyout.css({ visibility: 'hidden', opacity: '0' });
          $linkLi.removeClass('meganav__link--active');
        }
      });
    });
  }

  jQuery(document).ready(function() {
    setTimeout(initMegaMenuFlyouts, 100);
    setTimeout(initMegaMenuFlyouts, 500);
    setTimeout(initMegaMenuFlyouts, 1500);
  });

  jQuery(document).on('turbo:load turbolinks:load', initMegaMenuFlyouts);
})();
